<template>
  <div v-frag>
    <CardIeaAppMain>
      <!-- <div v-if="user.tipoUsuario == 'alumno'" style="width: 100%">
        <div v-if="docsPend == 0 && waiting == false" style="width: 100%">
          <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
            <v-card elevation="0" class="rounded-xl" color="secondaryApp">
              <v-card-title style="
                  display: flex;
                  justify-content: center;
                  background-color: rgb(58, 66, 153);
                  color: white;
                ">
                Documentación Completa
              </v-card-title>
            </v-card>
          </v-col>
        </div>
        <div v-else>
          <v-col v-if="docsPend > 0" cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
            <v-card elevation="0" class="rounded-xl" color="secondaryApp">
              <v-card-title> Documentos Requeridos: </v-card-title>
              <v-card-text>
                <ul class="text--primary">
                  <div v-for="(documento, index) in documentosAlumno" :key="index">
                    <li
                      v-if="documento.validar == 0 && documento.nameDocumento != 'Formulario de Contacto a Inscripción'">
                      {{ documento.nameDocumento }}
                    </li>
                    <li
                      v-else-if="documento.validar == 0 && documento.nameDocumento == 'Formulario de Contacto a Inscripción'">
                      <router-link to="/contactoDatos">{{ documento.nameDocumento }}</router-link>
                    </li>

                  </div>
                </ul>
              </v-card-text>
            </v-card>
          </v-col>
        </div>

        <v-col v-if="waiting == false" cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
          <v-card elevation="0" class="rounded-xl" color="secondaryApp">
            <v-card-title>
              {{ tituloNovedades }}
            </v-card-title>
            <v-card-text>
              <div class="text--primary">
                {{ descripcionNovedades }}
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col v-if="llenarFormulario != false" cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
          <v-alert title="Formulario de Inscripción BCE" prominent type="info">
            Tienes pendiente el llenado del formulario de inscripción de contacto. {{ (existeContactoBce ? ('Completar antes de: '+(contactoBce.fecha_atencion+' a las '+contactoBce.hora_atencion)):'') }} <router-link
              to="contactoDatos" class="text-button white--text">Llenar Formulario</router-link>
          </v-alert>
        </v-col>
        <v-col v-if="existeContactoBce != false" cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
          <v-alert title=" Reunión para Inscripción a Materias" prominent type="info">
            Tiene una reunión para inscripción a materias el día {{ contactoBce.fecha_atencion }} a las
            {{ contactoBce.hora_atencion }} {{ ((contactoBce.usuario) ? 'con ' + contactoBce.usuario.usu_nombre : '.') }}
          </v-alert>
        </v-col>
        <v-col v-if="user.validacion_inscripcion == 0" cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
          <v-alert title="Documentos de inscripción" prominent type="info">
            Tienes pendiente la validación de tus documentos de inscripción !
          </v-alert>
        </v-col>
        <div class="text-center">
          <v-dialog v-model="dialog_pago_atrasado" width="700">
            <v-card>
              <v-card-text>
                <br />
                <h4>
                  Estimado/a alumno/a; al dia de la fecha tiene cuota/s impagas,
                  por favor procure realizar los pagos lo antes posible, a fin
                  de evitar el pasaje automático de su cuenta a estado de mora.
                  Puede regularizar su deuda desde la sección "Pagar curso"; o
                  enviar una consulta para que le indiquen los pasos a seguir.
                </h4>
              </v-card-text>
              <v-card-actions>
                <v-btn color="warning" block @click="dialog_pago_atrasado = false">Cerrar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>

        <div v-if="user.alumno_mora" style="width: 100%">
          <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
            <v-alert prominent type="error">
              Su usuario se encuentra en estado de Mora. Si desea retomar sus
              estudios, puede regularizar su deuda desde la sección Pagar curso;
              o enviar una consulta para que le indiquen los pasos a seguir para
              obtener el alta
            </v-alert>
          </v-col>
        </div>
        <div v-else-if="user.borrado == '1'" style="width: 100%">
          <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
            <v-alert prominent type="error">
              Su usuario se encuentra dado de baja. Si desea retomar sus
              estudios, puede regularizar su deuda desde la sección Pagar curso;
              o enviar una consulta para que le indiquen los pasos a seguir para
              obtener el alta
            </v-alert>
          </v-col>
        </div>
      </div> -->

      <!-- <v-row justify="center" align-content="center" align="start"> -->
      <v-row>
        <v-col cols="12">
          <v-row>
            <!-- Columna izquierda de bienvenida y medallas -->
            <v-col cols="12" sm="12" md="4" lg="4" class="d-none d-md-flex">
              <v-card class="pa-4 card-background rounded-xl" elevation="2" height="630">
                <div class="card-content d-flex flex-column pa-5 rounded-xl">
                  <h2 class="white--text">¡Bienvenido/a!</h2>
                  <p class="white--text">Nos alegra verte de nuevo.</p>
                  <h4 class="white--text">Aviso importante</h4>
                  <p class="white-text" style="visibility: hidden;">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Exercitationem, adipisci at veritatis repellat recusandae
                    accusamus, consequuntur ad quas quo distinctio quod sunt non
                    nostrum. Soluta quam perspiciatis sint dolorum at!
                  </p>
                  <!--<div class="mt-16">
                      <v-card flat class="pa-0 card-background-transparent mt-auto">
                        <v-card-title class="white--text">Tus medallas - <span>Posición: #{{ posicionRanking }}</span></v-card-title>
                        <v-row class="flex-direction-row justify-center d-md-flex mr-5 align-baseline">
                          <v-col cols="2" sm="2" xs="2" md="2" lg="2" xl="2" style="text-align: center;">
                            <v-img style="cursor: pointer;" @click="mostrarModalInicial()" :aspect-ratio="1.4"
                              title="¡Gracias por ingresar a la plataforma!" width="120" contain
                              :src="require('../assets/inicial.png')"></v-img>
                          </v-col>
                          <v-col cols="2" sm="2" xs="2" md="2" lg="2" xl="2" :style="tieneBadge1 ? 'text-align: center;' : 'text-align: center;'">
                            <v-img style="cursor: pointer;" @click="!tieneBadge1 ? modalBadge(1) : modalBadgeGanado(1)"
                              :class="!tieneBadge1 ? 'badge-no' : ''" :aspect-ratio="1.4"
                              :title="tieneBadge1 ? 'Premio Perseverancia: ¡3 días seguidos estudiando!' : ''"
                              width="120" contain :src="require('../assets/bronce2.png')"></v-img>
                            <v-progress-linear rounded v-if="!tieneBadge1" class="mt-2" v-model="porcentaje1" height="13"></v-progress-linear>
                          </v-col>
                          <v-col v-if="tieneBadge1" cols="2" sm="2" xs="2" md="2" lg="2" xl="2"
                            :style="tieneBadge2 ? 'text-align: center;' : 'text-align: center;'">
                            <v-img style="cursor: pointer;" @click="!tieneBadge2 ? modalBadge(2) : modalBadgeGanado(2)"
                              :class="!tieneBadge2 ? 'badge-no' : ''" :aspect-ratio="1.4"
                              :title="tieneBadge2 ? 'Premio Perseverancia: ¡5 días seguidos estudiando!' : ''"
                              width="120" contain :src="require('../assets/plata2.png')"></v-img>
                            <v-progress-linear rounded v-if="!tieneBadge2" class="mt-2" v-model="porcentaje2" height="13"></v-progress-linear>
                          </v-col>
                          <v-col v-if="tieneBadge2" cols="2" sm="2" xs="2" md="2" lg="2" xl="2"
                            :style="tieneBadge3 ? 'text-align: center;' : 'text-align: center;'">
                            <v-img style="cursor: pointer;" @click="!tieneBadge3 ? modalBadge(3) : modalBadgeGanado(3)"
                              :class="!tieneBadge1 ? 'badge-no' : ''" :aspect-ratio="1.4"
                              :title="tieneBadge3 ? 'Premio Perseverancia: !10 días seguidos estudiando!' : ''"
                              width="120" contain :src="require('../assets/oro2.png')"></v-img>
                            <v-progress-linear rounded v-if="!tieneBadge3" class="mt-2" v-model="porcentaje3" height="13"></v-progress-linear>
                          </v-col>
                        </v-row>
                      </v-card>
                    </div>-->
                </div>
              </v-card>
            </v-col>

            <!-- Columna derecha de tarjetas -->
            <v-col cols="12" sm="12" md="8" lg="8">
              <v-row class="d-flex align-stretch">
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-row class="d-flex align-stretch">
                    <!-- Renderizado de los items del menú con el botón de abrir modal -->
                    <v-col cols="12" xs="6" sm="6" md="3" lg="2" v-for="(item, index) in menuValidar" :key="index">
                      <CardIeaCategory :text="item.text" :color="(user.borrado == '1' || user.alumno_mora) &&
                        item.validate
                        ? '#dfdfdf'
                        : item.color
                        " :icon="item.icon_bce" :newOption="item.new" v-if="item.show" @press="
                          item.id
                            ? openModal(item)
                            : menuAction(item.route, item.validate)
                          " />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- </v-row> -->
    </CardIeaAppMain>
    <br />
    <div v-if="
      user.borrado !== '1' &&
      user.alumno_mora !== true &&
      user.validacion_inscripcion != 0
    " :class="!showMenu ? 'hidden' : ''" style="margin-bottom: 85px">
      <div v-frag v-for="(item, i) in panels" :key="i">
        <v-card :class="$vuetify.breakpoint.name == 'xs'
          ? 'rounded-xl pr-4 pl-4'
          : 'rounded-xl pr-8 pl-8'
          " color="cardOne" v-if="item.id != 0" style="margin-bottom: 25px">
          <!-- <v-container :class="$vuetify.breakpoint.name == 'xs' ? '' :'pr-8 pl-8'" fluid> -->
          <v-row align="center" justify="center" align-content="center" v-if="user.tipoUsuario == 'alumno'">
            <v-col cols="12">
              <v-row @click="openModal(item)" no-gutters>
                <v-col cols="9" align-self="center">
                  <div class="text-xs-h5 text-sm-h5 text-md-h5 text-lg-h5 text-xl-h5 grey--text text--darken-2">
                    {{ item.text }}
                  </div>
                </v-col>
                <v-col cols="3" align-self="center" class="d-flex justify-end">
                  <v-avatar color="background" rounded class="rounded-lg" size="45">
                    <v-icon color="#8fc6dc" x-large v-if="!item.active">mdi-menu-down</v-icon>
                    <v-icon color="#8fc6dc" x-large v-if="item.active">mdi-menu-up</v-icon>
                  </v-avatar>
                </v-col>
              </v-row>

              <!-- Modal para cada item -->
              <v-dialog v-model="item.active" max-width="800px" scrollable>
                <v-card>
                  <!-- Título y botón de cierre en la parte superior -->
                  <v-card-title class="d-flex justify-space-between align-center"
                    style="background-color: #3A75A1; color: white;">
                    <span>{{ item.text }}</span>
                    <v-btn icon @click="item.active = false" style="color: white;">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>

                  <!-- Contenido del modal desplazable -->
                  <v-card-text style="max-height: 1000px; overflow-y: auto;">
                    <!-- Item.id 1: Mesa de Exámenes -->
                    <!-- <div v-if="item.id == 1">
                      <v-card-text v-if="item.data.cantidad > 0">
                        Cantidad de materia disponibles:
                        {{ item.data.cantidad }}
                      </v-card-text>
                      <v-card-text v-else>
                        Cantidad de materia disponibles: 0
                      </v-card-text>
                      <div v-for="(examenMesa, examenMesaKey) in item.data.data" :key="examenMesaKey">
                        <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary--text">
                          {{ examenMesa.curso.nombre }}
                        </div>
                        <v-simple-table>
                          <thead>
                            <tr>
                              <th class="text-left">Examen</th>
                              <th class="text-center">Acción</th>
                            </tr>
                          </thead>
                          <tbody> 
                            <tr v-for="(planDeEstudioData,
                              planDeEstudioDataKey) in examenMesa.curso
                                .plan_de_estudio_v2" :key="planDeEstudioDataKey">
                              <td>{{ planDeEstudioData.Materia }}</td>
                              <td class="text-center">
                                <template v-if="planDeEstudioData.tipo == 0">
                                  <v-btn disabled color="grey">Sin Mesa Aún</v-btn>
                                </template>
<template v-else-if="
                                  planDeEstudioData.tipo == 1 &&
                                  item.data.cantidad > 0
                                ">
                                  <v-btn @click="
                                    inscripcionMesaExamen(
                                      planDeEstudioData.IDStB,
                                      examenMesa.id
                                    )
                                    " text color="primary">Inscribir</v-btn>
                                </template>
<template v-else-if="planDeEstudioData.tipo == 2">
                                  <v-alert color="info">Esperando confirmación
                                    <v-btn @click="
                                      cancelarInscripcionMesaExamen(
                                        planDeEstudioData
                                          .examen_inscipcion_alumno[0]
                                          .id_validacion
                                      )
                                      " small color="red">Cancelar</v-btn>
                                  </v-alert>
                                </template>
<template v-else-if="planDeEstudioData.tipo == 3">
                                  <v-btn @click="
                                    linkPrueba(
                                      planDeEstudioData.examen_asociado
                                        .id_testpyr
                                    )
                                    " text color="info">Prueba</v-btn>
                                </template>
<template v-else-if="planDeEstudioData.tipo == 4">
                                  <v-badge color="error" content="Rechazado"></v-badge>
                                </template>
</td>
</tr>
</tbody>
</v-simple-table>
</div>
</div> -->
                    <div v-if="item.id == 1">
                      <v-card-text v-if="item.data.cantidad > 0">
                        Cantidad de materia disponibles: {{ item.data.cantidad }}
                      </v-card-text>
                      <v-card-text v-else>
                        Cantidad de materia disponibles: 0
                      </v-card-text>

                      <div v-for="(examenMesa, examenMesaKey) in item.data.data" :key="examenMesaKey">
                        <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary--text">
                          {{ examenMesa.curso.nombre }}
                        </div>

                        <v-simple-table>
                          <thead>
                            <tr>
                              <th class="text-left">Examen</th>
                              <th class="text-center">Estado</th>
                              <th class="text-center">Acción</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(planDeEstudioData, planDeEstudioDataKey) in examenMesa.curso.plan_de_estudio_v2"
                              :key="planDeEstudioDataKey">

                              <!-- tipos activos -->
                              <template v-if="
                                planDeEstudioData.tipo == 1 ||
                                planDeEstudioData.tipo == 2 ||
                                planDeEstudioData.tipo == 3 ||
                                planDeEstudioData.tipo == 4
                              ">

                                <td class="text-left">{{ planDeEstudioData.Materia }}</td>

                                <!-- COLUMNA: Estado / Motivo rechazo -->
                                <td class="text-center">
                                  <template v-if="
                                    planDeEstudioData.motivo_rechazo &&
                                    planDeEstudioData.validacion_pago == 'rechazada' &&
                                    planDeEstudioData.rechazo_pago == 1 &&
                                    planDeEstudioData.status != 0
                                  ">
                                    {{ planDeEstudioData.motivo_rechazo }}
                                  </template>
                                  <template v-else-if="
                                    planDeEstudioData.motivo_rechazo &&
                                    planDeEstudioData.validacion_academica == 'rechazada' &&
                                    planDeEstudioData.rechazo_pago === null &&
                                    planDeEstudioData.status != 0
                                  ">
                                    {{ planDeEstudioData.motivo_rechazo }}
                                  </template>
                                  <template v-else-if="
                                    planDeEstudioData.motivo_rechazo &&
                                    planDeEstudioData.rechazo_pago === null
                                  ">
                                    {{ planDeEstudioData.motivo_rechazo }}
                                  </template>
                                  <template v-else-if="
                                    planDeEstudioData.validacion_pago == 'rechazada' &&
                                    planDeEstudioData.validacion_academica == 'rechazada' &&
                                    planDeEstudioData.nuevo_monto_deuda <= 0 &&
                                    planDeEstudioData.status != 0
                                  ">
                                    {{ planDeEstudioData.motivo_rechazo }}
                                  </template>
                                </td>

                                <!-- COLUMNA: Acción -->
                                <td class="text-center">

                                  <!-- tipo == 0: Sin mesa -->
                                  <template v-if="planDeEstudioData.tipo == 0">
                                    <v-btn disabled color="grey">Sin Mesa Aún</v-btn>
                                  </template>

                                  <!-- tipo == 1: Inscribir con validaciones extendidas -->
                                  <template v-else-if="planDeEstudioData.tipo == 1">

                                    <!-- Días >= 550 y sin excepción: solicitar excepción -->
                                    <template v-if="
                                      planDeEstudioData.diasUltimaInscripcion >= 550 &&
                                      planDeEstudioData.excepcion_validacion == null
                                    ">
                                      <v-btn text color="primary"
                                        @click="exepcionValidacion(planDeEstudioData.IDStB, examenMesa.id)">Solicitar
                                        Excepción</v-btn>
                                    </template>

                                    <!-- Días >= 550 y excepción pendiente -->
                                    <template v-else-if="
                                      planDeEstudioData.diasUltimaInscripcion >= 550 &&
                                      planDeEstudioData.excepcion_validacion.status == null
                                    ">
                                      <v-btn text color="primary" disabled>Esperando Confirmación</v-btn>
                                    </template>

                                    <!-- Días >= 550 y excepción rechazada -->
                                    <template v-else-if="
                                      planDeEstudioData.diasUltimaInscripcion >= 550 &&
                                      planDeEstudioData.excepcion_validacion.status == 0
                                    ">
                                      <v-btn text color="red" disabled>Excepción Rechazada</v-btn>
                                    </template>

                                    <!-- Deuda pendiente: deshabilitar inscripción -->
                                    <template v-else-if="
                                      btnDeshabilitadoDeuda == true &&
                                      planDeEstudioData.diasUltimaInscripcion < 550
                                    ">
                                      <v-btn text color="primary" :disabled="true">Inscribir</v-btn>
                                    </template>

                                    <!-- Flujo normal de inscripción -->
                                    <template v-else>
                                      <!-- Con cupo disponible -->
                                      <v-btn v-show="extenderPeriodo == false &&
                                        item.data.cantidad > 0 &&
                                        examenMesa.cantidadInscipcion > 0
                                        " text color="primary"
                                        @click="inscripcionMesaExamen(planDeEstudioData.IDStB, examenMesa.id, examenMesa.cantidadInscipcion)">Inscribir</v-btn>

                                      <!-- Sin cupo -->
                                      <v-btn v-show="examenMesa.cantidadInscipcion == 0" text disabled
                                        color="default">Sin cupo</v-btn>

                                      <!-- Extensión de mesas habilitada -->
                                      <v-btn v-show="user.ext_mesas > 0" text color="primary"
                                        @click="inscripcionMesaExamen(planDeEstudioData.IDStB, examenMesa.id)">Inscribir</v-btn>
                                    </template>
                                  </template>

                                  <!-- tipo == 2: Esperando confirmación + cancelar -->
                                  <template v-else-if="
                                    planDeEstudioData.tipo == 2 &&
                                    planDeEstudioData.status != 0
                                  ">
                                    <v-alert color="info">
                                      Esperando confirmación
                                      <v-btn v-if="esFechaMenorOIgual(examenMesa.fechaTolerancia)" @click="cancelarInscripcionMesaExamen(
                                        planDeEstudioData.examen_inscipcion_alumno[0].id_validacion
                                      )" small color="red">Cancelar</v-btn>
                                    </v-alert>
                                  </template>

                                  <!-- tipo == 3: Prueba o ClassRoom según tipo_link -->
                                  <template v-else-if="planDeEstudioData.tipo == 3">
                                    <template v-if="planDeEstudioData.examen_asociado != null">
                                      <v-btn v-if="planDeEstudioData.examen_asociado.tipo_link == 0"
                                        @click="linkPrueba(planDeEstudioData.examen_asociado.id_testpyr)" text
                                        color="info">Prueba</v-btn>
                                      <v-btn v-else :href="planDeEstudioData.examen_asociado.google_meet_url"
                                        target="_blank" text color="error">ClassRoom</v-btn>
                                    </template>
                                    <template v-else>
                                      <v-alert color="success" dense
                                        style="display:inline-block; padding: 5px 24px; margin: 5px 0;">
                                        Inscripto
                                      </v-alert>
                                    </template>
                                  </template>

                                  <!-- tipo == 4: Rechazado -->
                                  <template v-else-if="planDeEstudioData.tipo == 4">
                                    <v-alert color="error" dense
                                      style="display:inline-block; padding: 5px 24px; margin: 5px 0; color: white;">Rechazado</v-alert>
                                  </template>

                                  <!-- Validación de pago rechazada con académica aceptada: re-inscribir -->
                                  <template v-if="
                                    btnDeshabilitadoDeuda == false &&
                                    planDeEstudioData.validacion_pago == 'rechazada' &&
                                    (planDeEstudioData.validacion_academica == 'aceptada' || planDeEstudioData.validacion_academica === null) &&
                                    planDeEstudioData.tipo != 4
                                  ">
                                    <v-btn v-show="item.data.cantidad > 0" text color="primary"
                                      @click="inscripcionMesaExamen(planDeEstudioData.IDStB, examenMesa.id)">Inscribir</v-btn>
                                  </template>

                                  <!-- status == 0 y tipo == null -->
                                  <template v-if="
                                    planDeEstudioData.status == 0 &&
                                    planDeEstudioData.tipo == null
                                  ">
                                    <v-btn v-show="item.data.cantidad > 0" text color="primary"
                                      @click="inscripcionMesaExamen(planDeEstudioData.IDStB, examenMesa.id)">Inscribir</v-btn>
                                  </template>

                                </td>
                              </template>

                              <!-- tipo == 0: fila simple sin columnas extra -->
                              <template v-else-if="planDeEstudioData.tipo == 0">
                                <td class="text-left">{{ planDeEstudioData.Materia }}</td>
                                <td></td>
                                <td class="text-center">
                                  <v-btn disabled color="grey">Sin Mesa Aún</v-btn>
                                </td>
                              </template>

                            </tr>
                          </tbody>
                        </v-simple-table>
                      </div>
                    </div>
                    <!-- Item.id 2: Class Room -->
                    <div v-if="item.id == 2">
                      <div v-if="$vuetify.breakpoint.name !== 'xs'">
                        <!-- Vista de Tabla en Pantalla Grande -->
                        <div v-for="(planDeEstudio, planDeEstudioKey) in item.data" :key="planDeEstudioKey">
                          <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary--text">
                            {{ planDeEstudio.CursoNombre }}
                          </div>
                          <v-simple-table>
                            <thead>
                              <tr>
                                <th class="text-left">Plan de estudio</th>
                                <th class="text-left">Código ClassRoom</th>
                                <th class="text-left">ClassRoom (BETA)</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(planDeEstudioData,
                                planDeEstudioDataKey) in planDeEstudio.planDeEstudio" :key="planDeEstudioDataKey">
                                <td>{{ planDeEstudioData.catedra }}</td>
                                <td>{{ planDeEstudioData.codClassRoom }}</td>
                                <td>
                                  <div v-if="planDeEstudioData.link != ''">
                                    <v-btn @click="linkVideo(planDeEstudioData)" text color="info">Ver Aquí</v-btn>
                                  </div>
                                  <div v-else>Sin contenido aún</div>
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </div>
                      </div>

                      <div v-else>
                        <!-- Vista de Tarjetas en Pantalla Pequeña -->
                        <div v-for="(planDeEstudio, planDeEstudioKey) in item.data" :key="planDeEstudioKey">
                          <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary--text">
                            {{ planDeEstudio.CursoNombre }}
                          </div>

                          <v-expansion-panels multiple>
                            <v-expansion-panel v-for="(planDeEstudioData,
                              planDeEstudioDataKey) in planDeEstudio.planDeEstudio" :key="planDeEstudioDataKey">
                              <!-- Header del panel con altura de línea ajustada -->
                              <v-expansion-panel-header :style="{
                                backgroundColor: 'rgb(58, 117, 161)',
                                color: 'white',
                                lineHeight: '2',
                              }">
                                {{
                                  $vuetify.breakpoint.name == "xs"
                                    ? planDeEstudioData.catedra
                                    : planDeEstudioData.catedra
                                }}
                              </v-expansion-panel-header>

                              <v-expansion-panel-content>
                                <!-- Información con separación de título e información -->

                                <!-- Título para Código ClassRoom con separación -->
                                <div style="margin-bottom: 16px;">
                                  <strong>Código ClassRoom:</strong>
                                  <div style="margin-top:10px">
                                    {{ planDeEstudioData.codClassRoom }}
                                  </div>
                                </div>

                                <!-- Título para el enlace de video con separación -->
                                <div v-if="planDeEstudioData.link != ''" style="margin-bottom: 16px;">
                                  <div><strong>ClassRoom (BETA):</strong></div>
                                  <v-btn @click="linkVideo(planDeEstudioData)" text color="info">Ver Aquí</v-btn>
                                </div>

                                <!-- Si no hay contenido, con título y separación -->
                                <div v-else style="margin-bottom: 16px;">
                                  <div><strong>Contenido:</strong></div>
                                  <div>Sin contenido aún</div>
                                </div>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </div>
                      </div>
                    </div>

                    <!-- Item.id 3: Pagos -->
                    <div v-if="item.id == 3">
                      <div v-for="(itemTable, keyTable) in item.data" :key="keyTable">
                        <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary--text">
                          {{ itemTable.nombre }}
                        </div>
                        <v-simple-table>
                          <thead>
                            <tr>
                              <th class="text-left">Concepto</th>
                              <th class="text-left">Monto</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(itemTableData,
                              keyItemTableData) in itemTable.data" :key="keyItemTableData">
                              <td>{{ itemTableData.Concepto }}</td>
                              <td>${{ itemTableData.Monto }}</td>
                            </tr>
                          </tbody>
                        </v-simple-table>
                      </div>
                    </div>

                    <!-- Item.id 4: Test -->
                    <div v-if="item.id == 4">
                      <v-simple-table>
                        <thead>
                          <tr>
                            <th class="text-center">Nombre del Test</th>
                            <th class="text-center">Test (BETA)</th>
                            <th class="text-center">Formulario Google</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(test, keyTable) in item.data" :key="keyTable">
                            <td>{{ test.titulo }}</td>
                            <td>
                              <v-btn @click="linkTest(test)" text color="info">Presentar Test</v-btn>
                            </td>
                            <td>
                              <v-btn :href="test.url_meet" text color="info">Ver Aquí</v-btn>
                            </td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </div>

                    <!-- Item.id 5: Materias Faltantes -->
                    <div v-if="item.id == 5">
                      <v-simple-table>
                        <thead>
                          <tr>
                            <th class="text-left">Materia</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(itemTableData,
                            keyItemTableData) in materiaFaltantes" :key="keyItemTableData">
                            <td v-if="
                              !itemTableData.aprobada ||
                              itemTableData.examen_inscipcion_alumno ==
                              null ||
                              itemTableData.examen_inscipcion_alumno.notas
                                .length == 0 ||
                              itemTableData.examen_inscipcion_alumno
                                .notas[3].nota < 4
                            ">
                              {{ itemTableData.catedra }}
                            </td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </div>

                    <!-- Item.id 6: Test Detallado -->
                    <div v-if="item.id == 6">
                      <!-- Tabla para pantallas grandes -->
                      <v-simple-table v-if="$vuetify.breakpoint.mdAndUp">
                        <thead>
                          <tr>
                            <th class="text-center">Materia</th>
                            <th class="text-center">Nombre del Test</th>
                            <th class="text-center">Tipo</th>
                            <th class="text-center">Fecha</th>
                            <th class="text-center">Hora</th>
                            <th class="text-center custom-btn-column">
                              Test (BETA)
                            </th>
                            <th class="text-center custom-btn-column">
                              Form URL
                            </th>
                            <th class="text-center">Nota</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(test, keyTable) in item.data" :key="keyTable">
                            <td>{{ test.nombreMateria }}</td>
                            <td>{{ test.titulo }}</td>
                            <td>{{ test.tipo_examen || "Practica" }}</td>
                            <td>
                              {{
                                test.tipo != "Practica"
                                  ? `${test.fecha_test_desde} / ${test.fecha_test_hasta}`
                                  : ""
                              }}
                            </td>
                            <td>
                              {{
                                test.tipo != "Practica"
                                  ? formatTime(test.hora_inicio) +
                                  " a " +
                                  formatTime(test.hora_final)
                                  : ""
                              }}
                            </td>
                            <td v-if="test.tipo == 'Practica'" class="custom-btn-column">
                              <v-btn @click="linkTest(test)" text color="info" class="custom-btn">
                                Presentar<br />Test
                              </v-btn>
                            </td>
                            <td v-else-if="test.tipo == 'Examen Final'">
                              <div v-if="
                                test.tipo_examen == 'Recuperatorio' &&
                                test.presentarExamenRecuperatorio
                              ">
                                <div v-frag v-if="
                                  test.testPresentado == false &&
                                  puedeRendirExamen(test) == true
                                ">
                                  <v-btn @click="linkTest(test)" small
                                    class="info--text text-decoration-underline font-weight-regular" depressed text
                                    color="info">Presentar Test</v-btn>
                                </div>

                                <div v-else-if="
                                  puedeRendirExamen(test) == false
                                ">
                                  <v-btn small color="danger">Test Cerrado</v-btn>
                                </div>

                                <div v-frag v-else>
                                  <v-btn small color="success">Test Presentado</v-btn>
                                </div>
                              </div>

                              <div v-else-if="
                                test.tipo_examen === 'Examen Final' &&
                                test.presentarExamenFinal === true
                              ">
                                <div v-frag v-if="
                                  test.testPresentado == false &&
                                  puedeRendirExamen(test) == true
                                ">
                                  <v-btn @click="linkTest(test)" small
                                    class="info--text text-decoration-underline font-weight-regular" depressed text
                                    color="info">Presentar Test</v-btn>
                                </div>

                                <div v-else-if="
                                  puedeRendirExamen(test) == false
                                ">
                                  <v-btn small color="danger">Test Cerrado</v-btn>
                                </div>

                                <div v-frag v-else>
                                  <v-btn small color="success">Test Presentado</v-btn>
                                </div>
                              </div>

                              <div v-else-if="
                                test.tipo_examen == '2do Parcial' ||
                                test.tipo_examen == '1er Parcial'
                              ">
                                <div v-frag v-if="
                                  test.testPresentado == false &&
                                  puedeRendirExamen(test) == true
                                ">
                                  <v-btn @click="linkTest(test)" small
                                    class="info--text text-decoration-underline font-weight-regular" depressed text
                                    color="info">Presentar Test</v-btn>
                                </div>

                                <div v-else-if="
                                  puedeRendirExamen(test) == false
                                ">
                                  <v-btn small color="danger">Test Cerrado</v-btn>
                                </div>

                                <div v-frag v-else>
                                  <v-btn small color="success">Test Presentado</v-btn>
                                </div>
                              </div>
                            </td>
                            <td class="custom-btn-column">
                              <a :href="test.url_meet" target="_blank">Ir a Formulario</a>
                            </td>
                            <td>
                              <v-badge v-if="test.mostrar_nota" :color="test.nota >= 4 ? 'success' : 'error'"
                                :content="test.nota"></v-badge>
                            </td>
                          </tr>
                        </tbody>
                      </v-simple-table>

                      <!-- Sistema de tarjetas para pantallas pequeñas -->
                      <v-container v-if="$vuetify.breakpoint.smAndDown" fluid>
                        <v-row v-for="(test, keyTable) in item.data" :key="keyTable" class="mb-2 justify-center">
                          <!-- Reducir el margen del v-col para que ocupe más espacio -->
                          <v-col :cols="12" :sm="10" :md="8" class="pa-0">
                            <v-expansion-panels style="width: 100%; margin: 0;">
                              <v-expansion-panel class="custom-panel"
                                style="margin: 0; padding: 0; border-bottom: 1px solid #e0e0e0; width: 98%;">
                                <!-- Header de la tarjeta con mayor espacio -->
                                <v-expansion-panel-header class="custom-panel-header"
                                  style="padding: 16px; margin: 0; font-weight: bold; background-color: rgb(58, 117, 161); color: white;">
                                  <div>{{ test.nombreMateria }}</div>
                                </v-expansion-panel-header>

                                <!-- Contenido de la tarjeta -->
                                <v-expansion-panel-content class="custom-panel-content"
                                  style="padding: 16px; margin: 0; width: 100%;">
                                  <div>
                                    <div class="mb-2">
                                      <strong>Nombre del Test:</strong>
                                      <br />
                                      {{ test.titulo }}
                                    </div>
                                    <div class="mb-2">
                                      <strong>Tipo:</strong>
                                      <br />
                                      {{ test.tipo_examen || "Practica" }}
                                    </div>
                                    <div class="mb-2">
                                      <strong>Fecha:</strong>
                                      <br />
                                      <span v-if="test.tipo != 'Practica'">{{ test.fecha_test_desde }} /
                                        {{ test.fecha_test_hasta }}</span>
                                      <span v-else>-</span>
                                    </div>
                                    <div class="mb-2">
                                      <strong>Hora:</strong>
                                      <br />
                                      <span v-if="test.tipo != 'Practica'">{{ formatTime(test.hora_inicio) }} a
                                        {{ formatTime(test.hora_final) }}</span>
                                      <span v-else>-</span>
                                    </div>
                                    <div class="mt-3 d-flex align-center">

                                      <v-btn v-if="test.tipo == 'Practica'" @click="linkTest(test)" text color="info"
                                        class="custom-btn">
                                        Presentar<br />Test
                                      </v-btn>
                                      <div v-else-if="test.tipo == 'Examen Final'">
                                        <div v-if="
                                          test.tipo_examen == 'Recuperatorio' &&
                                          test.presentarExamenRecuperatorio
                                        ">
                                          <div v-frag v-if="
                                            test.testPresentado == false &&
                                            puedeRendirExamen(test) == true
                                          ">
                                            <v-btn @click="linkTest(test)" small
                                              class="info--text text-decoration-underline font-weight-regular" depressed
                                              text color="info">Presentar Test</v-btn>
                                          </div>

                                          <div v-else-if="
                                            puedeRendirExamen(test) == false
                                          ">
                                            <v-btn small color="danger">Test Cerrado</v-btn>
                                          </div>

                                          <div v-frag v-else>
                                            <v-btn small color="success">Test Presentado</v-btn>
                                          </div>
                                        </div>

                                        <div v-else-if="
                                          test.tipo_examen === 'Examen Final' &&
                                          test.presentarExamenFinal === true
                                        ">
                                          <div v-frag v-if="
                                            test.testPresentado == false &&
                                            puedeRendirExamen(test) == true
                                          ">
                                            <v-btn @click="linkTest(test)" small
                                              class="info--text text-decoration-underline font-weight-regular" depressed
                                              text color="info">Presentar Test</v-btn>
                                          </div>

                                          <div v-else-if="
                                            puedeRendirExamen(test) == false
                                          ">
                                            <v-btn small color="danger">Test Cerrado</v-btn>
                                          </div>

                                          <div v-frag v-else>
                                            <v-btn small color="success">Test Presentado</v-btn>
                                          </div>
                                        </div>

                                        <div v-else-if="
                                          test.tipo_examen == '2do Parcial' ||
                                          test.tipo_examen == '1er Parcial'
                                        ">
                                          <div v-frag v-if="
                                            test.testPresentado == false &&
                                            puedeRendirExamen(test) == true
                                          ">
                                            <v-btn @click="linkTest(test)" small
                                              class="info--text text-decoration-underline font-weight-regular" depressed
                                              text color="info">Presentar Test</v-btn>
                                          </div>

                                          <div v-else-if="
                                            puedeRendirExamen(test) == false
                                          ">
                                            <v-btn small color="danger">Test Cerrado</v-btn>
                                          </div>

                                          <div v-frag v-else>
                                            <v-btn small color="success">Test Presentado</v-btn>
                                          </div>
                                        </div>
                                      </div>
                                      <v-badge v-if="test.mostrar_nota" :color="test.nota >= 4 ? 'success' : 'error'
                                        " :content="test.nota" class="ml-3"></v-badge>
                                    </div>
                                  </div>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </v-col>
                        </v-row>
                      </v-container>
                    </div>
                  </v-card-text>

                  <!-- Botón de cerrar al final -->
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="item.active = false">Cerrar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
          <!-- </v-container> -->
        </v-card>
      </div>
    </div>
    <div v-if="sendvalidation">
      <DialogValidationAlumno />
    </div>
    <v-dialog v-model="apareceModalMedallaIncial" width="auto">
      <v-card>
        <v-card-title class="headline" primary-title>
          ¡Felicidades!
        </v-card-title>
        <v-card-text class="mt-3 text-center d-flex flex-column justify-center align-center">
          Has ganado el siguiente reconocimiento por haber ingresado por primera
          vez a nuestra plataforma

          <v-img class="mt-4" :aspect-ratio="16 / 9" width="150" contain
            :src="require('../assets/inicial.png')"></v-img>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" block @click="apareceModalMedallaIncial = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import CardIeaAppMain from "../components/CardIeaAppMain";
import CardIeaCategory from "../components/CardIeaCategory";
import DialogValidationAlumno from "../components/DialogValidationAlumno";
import moment from "moment";
moment.locale("es");
// Configurar la zona horaria para todas las instancias de moment
moment.fn.toJSON = function () {
  return this.format();
};
moment.parseZone = function (input) {
  return moment(input).utcOffset(-180); // Argentina UTC-3
};
export default {
  name: "Home",
  props: {
    openModalId: {
      type: Number,
      default: null,
    },
  },
  components: {
    CardIeaAppMain,
    CardIeaCategory,
    DialogValidationAlumno,
  },
  created() {
    this.$API
      .get({
        url: "menus/B",
        data: {},
      })
      .then((res) => {
        this.menu = res.menus;
      });
  },
  data: () => ({
    item: {
      id: null,
      text: "",
      active: false,
      data: {},
    },
    showMenu: false, // Cambia a true para mostrar el menú
    selectedItem: {}, // Se usará para almacenar el item seleccionado
    tituloNovedades: "",
    descripcionNovedades: "",
    sendvalidation: false,
    documentosAlumno: [],
    waiting: true,
    docsPend: 0,
    materiaFaltantes: [],
    dialog_pago_atrasado: false,
    menu: [],
    posicionRanking: 0,
    extenderPeriodo: false,
    btnDeshabilitadoDeuda: false,
    today: moment().format("YYYY-MM-DD"),
    panels: [
      {
        id: 0,
        text: "Tus Inscripciones a Materias",
        active: false,
        data: [],
        tipoUsuario: ["alumno"],
        show: true,
        route: "/materias",
      },
      {
        id: 1,
        text: "Tus Inscripciones a Exámenes",
        active: false,
        data: [],
        tipoUsuario: ["alumno"],
        show: true,
        route: "/examenes",
      },
      {
        id: 2,
        text: "Plan de estudio y classroom",
        active: false,
        data: [],
        tipoUsuario: "alumno",
        route: "/plan-estudio",
      },
      {
        id: 3,
        text: "Mis Pagos",
        active: false,
        data: [],
        tipoUsuario: ["alumno"],
        show: true,
        route: "/pagos",
      },
      {
        id: 6,
        text: "Rendir Exámenes",
        active: false,
        data: [],
        tipoUsuario: "alumno",
        show: true,
        route: "/rendir-examenes",
      },
    ],

    showButtonClock: false,
    apareceModalMedallaIncial: false,
  }),

  watch: {
    openModalId(newId) {
      if (newId !== null) {
        this.openModal(newId); // Abre el modal al cambiar la URL
      }
    },
  },
  computed: {
    tieneBadge1() {
      return this.$store.getters.tieneBadge1;
    },
    tieneBadge2() {
      return this.$store.getters.tieneBadge2;
    },
    tieneBadge3() {
      return this.$store.getters.tieneBadge3;
    },
    porcentaje1() {
      return this.$store.getters.porcentaje1;
    },
    porcentaje2() {
      return this.$store.getters.porcentaje2;
    },
    porcentaje3() {
      return this.$store.getters.porcentaje3;
    },
    user() {
      return this.$store.getters.user;
    },
    menuValidar: function () {
      let usuario = this.$store.getters.user;
      let finalMenu = [];
      // Si el usuario es un alumno
      if (usuario.tipoUsuario == "alumno") {
        if (usuario.validacion_inscripcion != 0) {
          // Filtramos los elementos del menú base según el tipo de usuario
          let baseMenu = this.menu.filter((m) =>
            m.tipoUsuario.includes(usuario.tipoUsuario)
          );

          // Agregamos las tarjetas adicionales
          const additionalItems = [
            {
              id: 1,
              text: "Tus Inscripciones a Exámenes",
              color: "#1976D2",
              icon_bce: "mdi-clipboard-check-outline",
              route: "/inscripciones-examenes",
              validate: false,
              new: false,
              show: true,
              tipoUsuario: ["alumno"],
            },
            {
              id: 6,
              text: "Rendir Exámenes",
              color: "#1976D2",
              icon_bce: "mdi-pencil-outline",
              route: "/rendir-examenes",
              validate: false,
              new: false,
              show: true,
              tipoUsuario: ["alumno"],
            },
            {
              id: 3,
              text: "Mis Pagos",
              color: "#1976D2",
              icon_bce: "mdi-cash-multiple",
              route: "/mis-pagos",
              validate: false,
              new: false,
              show: true,
              tipoUsuario: ["alumno"],
            },
            {
              id: 2,
              text: "Plan de estudio y classroom",
              color: "#1976D2",
              icon_bce: "mdi-school-outline",
              route: "/plan-estudio-classroom",
              validate: false,
              new: false,
              show: true,
              tipoUsuario: ["alumno"],
            },
          ];

          // Concatenamos las tarjetas adicionales al menú filtrado y eliminamos "Salir"
          finalMenu = baseMenu
            .concat(additionalItems)
            .filter((item) => item.text !== "Salir");
        } else {
          // Si el usuario no ha validado la inscripción, solo se muestra "Documentos faltantes"
          finalMenu = [
            /*{
              icon: "5.png",
              new: 0,
              text: "Documentos faltantes",
              validate: 1,
              color: "#db1d4a",
              route: "Documento",
              tipoUsuario: ["alumno"],
              show: true
            }*/
          ];
        }
      } else {
        // Si el usuario no es "alumno", solo se muestra el menú base filtrado
        finalMenu = this.menu.filter((m) =>
          m.tipoUsuario.includes(usuario.tipoUsuario)
        ).filter((item) => item.text !== "Salir");
      }

      // Agregamos el botón "Salir" al final
      finalMenu.push({
        text: "Salir",
        color: "#db1d4a",
        icon_bce: "mdi-exit-to-app",
        route: "Logout",
        validate: false,
        new: false,
        show: true,
        tipoUsuario: [usuario.tipoUsuario],
      });

      return finalMenu;
    },

    apareceModalInicial() {
      return this.$store.getters.apareceModalInicial;
    },
    primeroIngreso() {
      return this.$store.getters.primeroIngreso;
    },
  },
  mounted() {
    if (this.openModalId !== null) {
      this.openModal(this.openModalId);
    }

    if (this.user.tipoUsuario == "alumno") {
      this.isActiveTramites();
      this.novedadesList();
      this.registerAccess();
      this.documentosRequeridos(this.user.IDStB);
      console.log(this.user.borrado);

      if (this.primeroIngreso && !this.apareceModalInicial) {
        this.apareceModalMedallaIncial = true;

        this.$store.commit("apareceModalInicial", true);
      }

      this.$API
        .get({
          url: "alumno/obtenerPosicion",
          data: {},
        })
        .then((res) => {
          this.posicionRanking = res.posicion;
        });
    }
    console.log(this.user);
    if (
      this.user.IDStB == 11103 ||
      this.user.IDStB == 5680 ||
      this.user.kanban
    ) {
      this.showButtonClock = true;
    }

    if (!this.getCookie("mensajeImpago")) {
      this.showMensajeImpago();
    }
    this.$API
      .get({
        url: "menus/B",
        data: {},
      })
      .then((res) => {
        console.log("resultado de la consulta ::: > ", res);
        this.menu = res.menus;
      });
  },
  methods: {
      esFechaMenorOIgual(fecha) {
        const fechaTolerancia = new Date(fecha);
        const fechaActual = new Date();
        return fechaTolerancia >= fechaActual;
      },
    formatTime(time) {
      if (!time) return "";
      const date = new Date(`1970-01-01T${time}Z`);
      return date
        .toLocaleString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
        .replace(":00", ""); // Eliminar los segundos
    },
    menuAction(route, validate) {
      // Valida la ruta y condiciones de usuario
      if (
        route &&
        (!validate ||
          (validate && this.user.borrado !== "1" && !this.user.alumno_mora))
      ) {
        switch (route) {
          case "Logout":
            this.logout();
            break;

          case "Verifier":
            this.$store.dispatch("omitirValidacion", false);
            this.sendvalidation = true;
            break;

          default:
            console.log(route);
            this.$router.push({ name: route });
        }
      } else {
        console.warn("Access denied or invalid route.");
      }
    },

    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) {
        const cookieValue = parts
          .pop()
          .split(";")
          .shift();
        return cookieValue;
      }
      return null;
    },
    puedeRendirExamen(examen) {
      const fechaDesde = moment(
        examen.fecha_test_desde + " " + examen.hora_inicio
      ).utcOffset(-180);
      const fechaHasta = moment(
        examen.fecha_test_hasta + " " + examen.hora_final
      ).utcOffset(-180);
      const now = moment().utcOffset(-180);

      return now.isBetween(fechaDesde, fechaHasta, null, "[]");
    },
    async showMensajeImpago() {
      let app = this;

      await this.$API
        .get({
          url: "alumno/status-activo/" + this.user.IDStB,
          data: {},
        })
        .then((res) => {
          const tomorrow = new Date();
          tomorrow.setDate(tomorrow.getDate() + 1);
          document.cookie = `mensajeImpago=${JSON.stringify(
            res
          )}; expires=${tomorrow.toUTCString()}; path=/`;
          app.dialog_pago_atrasado = res.is_active;
        });
    },

    async novedadesList() {
      //let that = this;
      await this.$API
        .get({
          url: "notificaciones/index",
          data: {},
        })
        .then((res) => {
          // Sin la guarda, un feed vacio es res[-1] === undefined y el home revienta
          // con TypeError al leer .titulo. Hoy no pasa porque siempre hay avisos
          // type='todos' activos, pero eso depende de los datos, no del codigo.
          if (!res || !res.length) return;
          this.tituloNovedades = res[res.length - 1].titulo.toUpperCase();
          this.descripcionNovedades = res[res.length - 1].descripcion;
        });
    },
    async registerAccess() {
      await this.$API
        .post({
          url: "alumno/register-access",
          data: {
            tipo: "web",
          },
        })
        .then((res) => {
          console.log(res);
        });
    },

    documentosPendientes() {
      let app = this;
      if (typeof app.documentosAlumno !== "undefined") {
        app.docsPend = 0;
        for (const item in app.documentosAlumno) {
          if (app.documentosAlumno[item].validar == 0) app.docsPend++;
        }
      }
    },

    async documentosRequeridos(alumno) {
      //let that = this;
      await this.$API
        .get({
          url: "documentos/requeridos/" + alumno,
          data: {},
        })
        .then((res) => {
          this.waiting = false;
          this.documentosAlumno = res;
          this.documentosPendientes();
        });
    },
    async logout() {
      let that = this;
      await this.$API
        .get({
          url: "alumno/logout?web=true",
          data: {},
        })
        .then(() => {
          setTimeout(() => {
            that.$store.dispatch("token", "");
            that.$store.dispatch("user", {});
            that.$store.dispatch("tieneBadge1", false);
            that.$store.dispatch("tieneBadge2", false);
            that.$store.dispatch("tieneBadge3", false);
            that.$store.dispatch("porcentaje1", 0);
            that.$store.dispatch("porcentaje2", 0);
            that.$store.dispatch("porcentaje3", 0);
            that.$store.dispatch("primeroIngreso", false);
            that.$store.dispatch("apareceModalInicial", false);
            that.$store.dispatch("carreraPrincipal", "");
            that.$store.dispatch("imagenbs", "");

            that.$router.replace({ name: "Login" });
          }, 1000);
        });
    },
    async openModal(item) {
      let selectedPanel;

      // Determinar si item es un ID o un objeto.
      if (typeof item === "number") {
        selectedPanel = this.panels.find((panel) => panel.id === item);
      } else {
        selectedPanel = this.panels.find((panel) => panel.id === item.id);
      }

      if (!selectedPanel) return;

      // Actualizar la URL sin el prefijo "home2"
      const routeName = {
        1: "examenes",
        2: "classroom",
        3: "pagos",
        4: "test",
        5: "materias-faltantes",
        6: "rendir-examenes",
      }[selectedPanel.id];

      if (routeName) {
        this.$router.push({ name: routeName }).catch(() => { }); // Evitar errores de navegación duplicada
      }

      console.log("selected panel", selectedPanel)
      // Lógica para manejar la acción del modal
      switch (selectedPanel.id) {
        case 1:
          if (!selectedPanel.active) await this.mesaDeExamen();
          break;
        case 2:
          if (!selectedPanel.active) await this.planDeEstudioGet();
          break;
        case 3:
          if (!selectedPanel.active) await this.tuPagos();
          break;
        case 4:
          if (!selectedPanel.active) await this.testPrueba();
          break;
        case 5:
          if (!selectedPanel.active) await this.MateriasFaltan();
          break;
        case 6:
          if (!selectedPanel.active) await this.examenes();
          break;
        default:
          break;
      }

      // Cambiar el estado del modal
      selectedPanel.active = !selectedPanel.active;
    },

    resetData(panelIndex) {
      this.panels[panelIndex].data = []; // Limpia los datos del panel especificado
    },

    async testPrueba() {
      console.log("cuatro");

      await this.$API
        .get({
          url: "pyr-test/select",
          data: {},
        })
        .then((res) => {
          this.panels.find((element) => element.id == 4).data = res;

          console.log("panel 4", this.panels[4].data);
        });
    },
    async examenes() {
      console.log("seis");

      await this.$API
        .get({
          url: "examenes",
          data: {},
        })
        .then((res) => {
          this.panels.find((element) => element.id == 6).data = res;
          console.log(res)
          console.log("panel 6", this.panels[6]);
        });
    },
    async planDeEstudioGet() {
      console.log("dos");
      await this.$API
        .get({
          url: "plan-de-estudio/index",
          data: {},
        })
        .then((res) => {
          this.panels[2].data = res;
        });
    },
    async mesaDeExamen() {
      console.log("uno");

      await this.$API
        .get({
          url: "examen/mesas",
          data: {},
        })
        .then((res) => {
          this.panels[1].data = res;
          this.btnDeshabilitadoDeuda = res.data.some(curso => {
            const materias = Object.values(curso.curso.plan_de_estudio_v2);
            return materias.some(materia => materia.rechazo_pago === 1);
          });
        });
    },
    async mesaDeMateria() {
      console.log("cero");

      await this.$API
        .get({
          url: "materia/mesas",
          data: {},
        })
        .then((res) => {
          this.panels[0].data = res;
        });
    },
    async tuPagos() {
      console.log("tres");

      await this.$API
        .get({
          url: "alumno/pagos",
          data: {},
        })
        .then((res) => {
          this.panels[3].data = res;
        });
    },

    async inscripcionMesaExamen(examen, mesa) {
      await this.$API
        .post({
          url: "examen/mesas-inscripcion",
          data: {
            materia_id: examen,
            examenMesa_id: mesa,
          },
        })
        .then(() => {
          this.mesaDeExamen();
        });
    },
    async cancelarInscripcionMesaExamen(id) {
      await this.$API
        .post({
          url: "examen/cancelar-inscripcion",
          data: {
            id: id,
          },
        })
        .then(() => {
          this.mesaDeExamen();
        });
    },

    async inscripcionMesaMateria(examen, mesa) {
      await this.$API
        .post({
          url: "materia/mesas-inscripcion",
          data: {
            materia_id: examen,
            examenMesa_id: mesa,
          },
        })
        .then(() => {
          this.mesaDeMateria();
        });
    },
    async cancelarInscripcionMesaMateria(id) {
      await this.$API
        .post({
          url: "materia/cancelar-inscripcion",
          data: {
            id: id,
          },
        })
        .then(() => {
          this.mesaDeMateria();
        });
    },
    async isActiveTramites() {
      await this.$API
        .get({
          url: "get-config/ENABLE_TRAMITES",
          data: {},
        })
        .then((res) => {
          console.log(res);
          if (res == "1") {
            if (this.menu[22]) {
              this.menu[22].show = true;
            }
          }
        });
    },
    async MateriasFaltan() {
      console.log("cinco");

      await this.$API
        .post({
          url: "examenes/v2/showCursoIea",
          data: {
            alumno: this.user.IDStB,
          },
        })
        .then((res) => {
          let cursos = res.data;
          let materias;

          cursos.forEach((planestudio) => {
            console.log(planestudio.plan_de_estudio_v2.length !== 0);
            if (planestudio.plan_de_estudio_v2.length !== 0) {
              materias = planestudio.plan_de_estudio_v2.filter(
                (materia) => materia.aprobada === false
              );
              if (materias.length > 0) {
                this.materiaFaltantes = materias.reduce(
                  (acc, el) => ({
                    ...acc,
                    [el.catedra]: el,
                  }),
                  []
                );
              }
            }
          });

          console.log(this.materiaFaltantes);
        });
    },
    linkVideo(link) {
      this.$router.push({
        name: "MateriaCodigoClaseVideoAuth",
        params: {
          catedra: link.catedra_uuid,
          planestudio: link.planEstudio,
        },
      });
    },
    linkTest(test) {
      this.$router.push({
        name: "examen",
        params: {
          test: test.test_id,
          examen: test.id,
        },
      });
    },

    linkPrueba(idPrueba) {
      this.$router.push({
        name: "examen",
        params: {
          test: idPrueba,
        },
      });
    },
  },
};
</script>
<style scoped>
::v-deep .v-btn__content {
  align-items: center;
  color: inherit;
  display: flex;
  flex: 1 0 auto;
  justify-content: center;
  /* Para centrar el texto */
  line-height: normal;
  font-size: 10px;
  position: relative;
  transition: inherit;
  transition-property: opacity;
  flex-wrap: wrap;
  /* Permite que el texto se ajuste en múltiples filas */
  text-align: center;
  /* Asegura que el texto esté centrado */
}

.custom-btn-column {
  width: 120px;
  max-width: 120px;
  padding: 0;
}

.custom-btn {
  width: 100%;
  max-width: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  word-wrap: break-word;
  /* Esto asegura que el texto se ajuste si es largo */
}

/* Evita el scroll horizontal */
body,
html {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
}

::v-deep .v-icon__svg {
  height: 24px;
  width: 24px;
  fill: white !important;
}

/* Asegura que los contenedores no excedan el tamaño de la pantalla */
.card-background,
.card-content {
  max-width: 100%;
  overflow: hidden;
}

/* Estilo para la columna para que se ajuste mejor */
.v-row {
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
}

.v-col {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

/* Asegúrate de que los elementos no sobresalgan de la pantalla */
.v-dialog {
  max-width: 100vw;
  /* Ajuste para diálogos */
}

.v-expansion-panels {
  border-radius: 4px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  list-style-type: none;
  padding: 0;
  width: 100%;
  margin-top: 10px;
  z-index: 1;
}

::v-deep .v-expansion-panel-content__wrap {
  padding: 0 24px 16px;
  flex: 1 1 auto;
  max-width: 100%;
  margin-top: 15px !important;
}

.card-background {
  background-image: url("../assets/students.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: inherit;
  height: 100%;
  /* Para garantizar que la tarjeta no se sobrepase */
}

.card-content {
  position: relative;
  z-index: 30;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 10px;
}

.hidden {
  display: none;
}

::v-deep .v-application .mb-2 {
  margin-bottom: 0px !important;
}

/* Ajustes en tamaños de tarjeta en diferentes dispositivos */
@media screen and (max-width: 600px) {
  .v-row {
    padding-left: 0;
    padding-right: 0;
  }

  .card-content {
    padding: 15px;
  }

  ::v-deep .custom-panel {
    margin-bottom: 0px !important;
    /* Reduce la separación entre las tarjetas */
    margin-top: 0px !important;
  }

  ::v-deep .v-application .mb-2 {
    margin-bottom: 0px !important;
  }

  .custom-panel-header {
    padding: 8px;
    /* Reduce el padding del header */
    font-size: 16px;
  }

  .custom-panel-content {
    padding: 8px;
    /* Espaciado interno uniforme */
  }

  .custom-panel-content div {
    line-height: 1.6;
    /* Mejora la separación entre líneas */
  }

  .v-dialog>.v-card>.v-card__title {
    font-size: 1rem;
    font-weight: 500;
    letter-spacing: 0.0125em;
    padding: 16px 24px 10px;
  }

  .v-dialog--scrollable>.v-card>.v-card__text,
  .v-dialog--scrollable>form>.v-card>.v-card__text {
    backface-visibility: hidden;
    flex: 1 1 auto;
    overflow-y: auto;
    margin-top: 10px;
  }

  ::v-deep .v-btn__content {
    align-items: center;
    color: inherit;
    display: flex;
    flex: 1 0 auto;
    justify-content: inherit;
    line-height: normal;
    position: relative;
    transition: inherit;
    transition-property: opacity;
    font-size: 0.65rem !important;
  }
}
</style>
